<template>
</template>

<script>
</script>

<style>
</style>
<template>
  <!--
    	作者：zct
    	时间：2021-10-08
    	描述：队伍-添加队伍
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="80px">
      <!--添加队伍-->
      <div class="common-form">添加队伍</div>

      <el-form-item label="队伍名称" prop="unit_group_name" :rules="[{required: true,message: ' '}]">
        <el-input v-model="form.unit_group_name" placeholder="请输入队伍名称" class="max-w460"></el-input>
      </el-form-item>
      <!-- <el-form-item label="队伍logo">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload">选择图片</el-button>
          <div v-if="form.logo_image_id!=''" class="img">
            <img :src="file_path" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item> -->
      <!-- <el-form-item label="队长ID" >
         <el-input type="text" v-model="form.group_user_id" autocomplete="off" style="width:180px"  readonly="">
         <el-button slot="append" type="primary" icon="el-icon-user-solid" @click="openUserDialog()">选择用户</el-button>
         </el-input>

       </el-form-item> -->

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
    <!--用户选择-->
    <GetUser :is_open="open_user" @close="closeUserDialog"></GetUser>
  </div>
</template>

<script>

  import unitApi from '@/api/unit.js';
  import Upload from '@/components/file/Upload';
  import GetUser from '@/components/user/GetUser.vue';
  export default {
    components: {

      Upload,
      GetUser
    },
    data() {
      return {
        /*切换菜单*/
        // activeIndex: '1',
        /*form表单数据*/
        form: {
          unit_group_name: '',
          unit_id:'',
          group_user_id:''
        },
        file_path: '',
        /*省市区*/
        areaList: [],
        /*是否上传图片*/
        isupload: false,
        loading: false,
        position:[],
        open_user:false,
        userList:[],
        group:[],

      };
    },
    created() {
      this.form.unit_id =this.$route.query.unit_id;
      /*引用的select_region 初始化*/
      this.getData();
    },

    methods: {
      getData(){

      },
      /*添加用户*/
      onSubmit() {
        let self = this;
        let form = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            unitApi.addGroup(form, true)
              .then(data => {
                self.loading = false;
                if (data.code == 1) {
                  self.$message({
                    message: '恭喜你，添加成功',
                    type: 'success'
                  });
                  self.$router.push({path:'/unit/group/index',query:{unit_id:self.form.unit_id}});
                } else {
                  self.loading = false;
                }
              })
              .catch(error => {
                self.loading = false;
              });
          }
        });


      },

      /*上传*/
      openUpload(e) {
        this.type = e;
        this.isupload = true;
      },

      /*获取图片*/
      returnImgsFunc(e) {
        if (e != null && e.length > 0) {
          this.file_path = e[0].file_path;
          this.form.logo_image_id = e[0].file_id;
        }
        this.isupload = false;
      },



      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      /*打开用户弹窗*/
      openUserDialog() {

        this.open_user = true;
      },
      /*关闭用户弹窗*/
      closeUserDialog(e) {
        if (e.type != 'error') {
          this.form.group_user_id = e.params[0].user_id;

        }
        this.open_user = false;
      },

    }

  };
</script>

<style lang="scss" scoped>
  .basic-setting-content {}

  .product-add {
    padding-bottom: 50px;
  }

  .img {
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/unit/group/add.vue